import { useEffect, useState } from 'react';

const isBodyDark = () =>
  typeof document !== 'undefined' && document.body.classList.contains('dark');

const useDarkTheme = () => {
  const [isDark, setIsDark] = useState(isBodyDark);

  useEffect(() => {
    const updateTheme = () => setIsDark(isBodyDark());
    const observer = new MutationObserver(updateTheme);

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });
    updateTheme();

    return () => observer.disconnect();
  }, []);

  return isDark;
};

export default useDarkTheme;
